import { render, staticRenderFns } from "./userPage.vue?vue&type=template&id=29232b46&scoped=true"
import script from "./userPage.vue?vue&type=script&lang=js"
export * from "./userPage.vue?vue&type=script&lang=js"
import style0 from "./userPage.vue?vue&type=style&index=0&id=29232b46&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29232b46",
  null
  
)

export default component.exports